import { InsuranceStateTypes, InsuranceActionTypes } from "./Insurance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: InsuranceStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const InsuranceReducer = (
  state: InsuranceStateTypes = INITIAL_STATE,
  action: any
): InsuranceStateTypes => {
  switch (action.type) {
    case InsuranceActionTypes.FETCH_ALL_INSURANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InsuranceActionTypes.FETCH_ALL_INSURANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case InsuranceActionTypes.FETCH_ALL_INSURANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InsuranceActionTypes.FETCH_ALL_INSURANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case InsuranceActionTypes.FETCH_ONE_INSURANCE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case InsuranceActionTypes.FETCH_ONE_INSURANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case InsuranceActionTypes.FETCH_ONE_INSURANCE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InsuranceActionTypes.FETCH_ONE_INSURANCE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default InsuranceReducer;
